import { Component, Input, Output, OnChanges, EventEmitter, SimpleChanges, Optional } from '@angular/core';

import { UserFormService } from '../user-form/user-form.service';

@Component({
    selector: 'user-check',
    templateUrl: './user-check.component.html',
    styleUrls: ['./user-check.component.css']
})
export class UserCheckComponent {
    @Input() value: boolean;
    @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();
    @Input() label: string;
    @Input() description: string;
    errors: string[];
    isTouched: boolean = false;

    constructor(@Optional() private service?: UserFormService) {

    }

    get currentValue() {
        return this.value;
    }

    set currentValue(newValue: boolean) {
        if (newValue !== this.value) {
            this.value = newValue;
            this.valueChange.emit(this.value);

            if (this.service) {
                this.service.inputChanged.emit(this.value);
            }
        }
    }

    toggleCheck() {
        this.currentValue = !this.currentValue;
    }

    controlFocused() {
        this.isTouched = true;
    }
    
    getName() {
        return this.label;
    }

    isValid() {
        return true;
    }
}

interface IValidationMessage {
    value: any;
    message: string;
}
